import { EQuizMode, EQuizModeEmojiIcon } from '@constants';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  value: EQuizMode;
};

export const QuizModeBadge: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation('ManagerQuizzesTranslations');

  const emoji = useMemo(() => EQuizModeEmojiIcon[value], [value]);

  return (
    <span role="img" aria-label="Inspector">
      {emoji} {t(value)}
    </span>
  );
};
